<template>
    <div class="wout-login">
        <div class="center">
            <div>
                <img src="@/assets/img/pgtoaprovado.svg" 
                    width="auto" height="130" alt="Pagamento aprovado!" crossorigin />
            </div>
            <span class="aprovado">Pagamento aprovado!</span>
        </div>
    </div>
</template>
<script>

export default {
    data: () => {
        return {
            
        }
    }
}
</script>

<style scoped>
.center {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: center;
}
.aprovado {
    font-weight: normal;
    color: white!important;
    padding: 10px;
}
</style>